import { AxiosResponse } from "axios";
import Api from "./Api";

type TestRequestHistoryEntry = TestRequestRaw.Schemas.TestRequestHistoryEntry;

class TestRequestHistoryApi {
  constructor(private api: Api) {}

  public fetchTestRequestHistory(testRequestId: string): Promise<AxiosResponse<TestRequestHistoryEntry[]>> {
    return this.api.get(`/test-request/v2/testrequests/${testRequestId}/history`);
  }
}

export default TestRequestHistoryApi;
